module.exports = "/_next/static/images/4ffe172d05527821650b66388f1fcab0-bars-xs.jpg.webp";